import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const getGroupTopicByID = (groupTopicID) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.ORGANIZE.GET_GROUP_TOPIC_BY_ID(groupTopicID)
  );
};

export default getGroupTopicByID;
